module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/accordian/accordian-style2/accordian-style2.component.scss
// module id = ./src/app/features/accordian/accordian-style2/accordian-style2.component.scss
// module chunks = main